import React, { useEffect, useState } from "react";
import "./My_Account.css";
import Left_Tabs from "./left_tabs/Left_Tabs";
import Personal_Info from "./all_tabs/personal_info/Personal_Info";
import In_Transit from "./all_tabs/in_transit/In_Transit";
import Delivered from "./all_tabs/delivered/Delivered";
import Returned from "./all_tabs/returned/Returned";
import Canceled from "./all_tabs/canceled/Canceled";
import Prescriptions from "./all_tabs/prescriptions/Prescriptions";
import Appointments from "./all_tabs/appointments/Appointments";
import Reward from "./all_tabs/reward/Reward";
import OrderCard from "./all_tabs/order_card/OrderCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDeliverOrder,
  getAllOrder,
} from "../../features/order/orderSlice";
import { formatDateTime } from "../../utils/common";
import { AiOutlineInbox } from "react-icons/ai";
import { AiOutlineCheckCircle } from "react-icons/ai";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../features/user/userSlice";
import { setIsSignedOut } from "../../features/auth/authSlice";
import { Spinner } from "react-bootstrap";

import Terms_Conditions from "../terms_conditions/Terms_Conditions";
import Privacy_Policy from "../privacy_policy/Privacy_Policy";

const My_Account = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const is_signin = useSelector((state) => state.auth.is_signin);
  const userStatus = useSelector((state) => state.user.status);

  useEffect(() => {
    // if (is_signin) {
    dispatch(getUserInfo());
    // }
  }, [is_signin, dispatch]);

  useEffect(() => {
    if (
      userStatus !== "loading" &&
      is_signin &&
      (!user || Object.keys(user).length === 0)
    ) {
      Cookies.remove("bapat_optics_security");
      dispatch(setIsSignedOut());
      navigate("/");
    }
  }, [is_signin, user]);

  const [selectedTab, setSelectedTab] = useState("Personal Details");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allOrder = useSelector((state) => state.order.allOrders);

  useEffect(() => {
    dispatch(getAllOrder({ order_status_id: [1, 2, 3, 4, 10] }));
  }, [dispatch]);

  const allDeliverOrder = useSelector((state) => state.order.allDeliverOrders);

  useEffect(() => {
    dispatch(getAllDeliverOrder({ order_status_id: [5, 7] }));
  }, [dispatch]);

  return (
    <section className="My_Account">
      <div className="container-fluid">
        <div className="main_content_div">
          <div className="account_layout">
            <div className="sidebar_slot">
              <Left_Tabs
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
              />
            </div>

            <div className="content_slot">
              <div className="tabs_container">
                {selectedTab === "Personal Details" && <Personal_Info />}

                {selectedTab === "In-Transit" && (
                  <>
                    {allOrder?.data?.length > 0 ? (
                      allOrder.data.map((val, index) => (
                        <OrderCard
                          key={index}
                          navigate={`/order-details/${val?.id}`}
                          title={val?.Product?.name}
                          showtracking={
                            val?.order_status_id === 10 ? false : true
                          }
                          footer_text_color="#007C08"
                          img={process.env.REACT_APP_IMAGE_URL + val?.image}
                          orderId={`Order ID #${val?.invoice_no}`}
                          orderStatusId={val?.order_status_id}
                          items={`${val?.no_of_item} Items`}
                          kwd={Number(val?.total_amount).toFixed(2)}
                          date={formatDateTime(val?.createdAt)}
                          data={val}
                        />
                      ))
                    ) : (
                      <div className="empty-state text-center my-5">
                        <AiOutlineInbox
                          size={80}
                          color="#888"
                          style={{ marginBottom: "20px" }}
                        />
                        <h5>No orders in transit yet</h5>
                        <p>
                          Your orders will appear here when they are on the way.
                        </p>
                      </div>
                    )}
                  </>
                )}

                {selectedTab === "Delivered" && (
                  <>
                    {allDeliverOrder?.data?.length > 0 ? (
                      allDeliverOrder.data.map((val, index) => (
                        <OrderCard
                          key={index}
                          navigate={`/order-details/${val?.id}`}
                          title={val?.Product?.name}
                          showtracking={false}
                          footer_text_color="#007C08"
                          img={process.env.REACT_APP_IMAGE_URL + val?.image}
                          orderId={`Order ID #${val?.invoice_no}`}
                          orderStatusId={val?.order_status_id}
                          items={`${val?.no_of_item} Items`}
                          kwd={Number(val?.total_amount).toFixed(2)}
                          date={formatDateTime(val?.createdAt)}
                          data={val}
                        />
                      ))
                    ) : (
                      <div className="empty-state text-center my-5">
                        <AiOutlineCheckCircle
                          size={80}
                          color="#28a745"
                          style={{ marginBottom: "20px" }}
                        />
                        <h5>No delivered orders yet</h5>
                        <p>
                          Your delivered orders will appear here once completed.
                        </p>
                      </div>
                    )}
                  </>
                )}

                {/* {selectedTab === "Returned" && (<Returned />)}

                {selectedTab === "Canceled" && <Canceled />} */}

                {selectedTab === "Prescriptions" && <Prescriptions />}

                {/* {selectedTab === "Appointments" && <Appointments />} */}

                {selectedTab === "Rewards" && <Reward />}

                {selectedTab === "Terms & Conditions" && (
                  <div className="policy_tab">
                    <Terms_Conditions />
                  </div>
                )}

                {selectedTab === "Privacy Policy" && (
                  <div className="policy_tab">
                    <Privacy_Policy />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default My_Account;